import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Link, Typography } from '@mui/material';

// project imports
import { DASHBOARD_PATH } from 'config';
import Logo from 'ui-component/Logo';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    // <Link component={RouterLink} to={DASHBOARD_PATH}>
       <Typography variant='h1'>Dhruva <span style={{ fontSize: "0.70em",mt:'0.1rem' }}> — The Samrat Command Centre</span></Typography>
    // </Link>
);

export default LogoSection;
